/*
 * @Author: Zhouqi
 * @Date: 2026-01-30 18:14:01
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-02-03 11:34:19
 */
import { ModelTypeEnum } from '@/utils/const';

import {
  imageToImageModelConfig,
  imageToVideoModelConfig,
  ModelIdEnum,
  textToImageModelConfig,
  textToVideoModelConfig,
  videoEditModelConfig,
} from './config';

// Re-export ModelIdEnum to maintain compatibility
export { ModelIdEnum };

export const modelConfig: Record<ModelTypeEnum, any[]> = {
  [ModelTypeEnum.T2V]: textToVideoModelConfig,
  [ModelTypeEnum.I2V]: imageToVideoModelConfig,
  [ModelTypeEnum.T2I]: textToImageModelConfig,
  [ModelTypeEnum.I2I]: imageToImageModelConfig,
  [ModelTypeEnum.VET]: videoEditModelConfig,
};
